import script from "./file-type-policy-form.vue?vue&type=script&setup=true&lang=js"
export * from "./file-type-policy-form.vue?vue&type=script&setup=true&lang=js"

import "./file-type-policy-form.vue?vue&type=style&index=0&id=c07381ea&lang=css"

const __exports__ = script;

export default __exports__